import { render, staticRenderFns } from "./FiscalPaymentStatus.vue?vue&type=template&id=2009489a&scoped=true&"
import script from "./FiscalPaymentStatus.vue?vue&type=script&lang=js&"
export * from "./FiscalPaymentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2009489a",
  null
  
)

export default component.exports